// Field-name keys returned by /folder-stats, /database-stats, and used to lay out
// repoStatsConfig/repoStatsDbConfig. Centralized here so comparisons/formatting logic
// (e.g. repositoryStats.jsx) and the layout config stay in sync with one source of truth.
export const RepoStatKey = Object.freeze({
    NO_OF_FILES: 'noOfFiles',
    TOTAL_SIZE: 'totalSize',
    TOTAL_PAGES: 'totalPages',
    TOTAL_TABLES: 'totalTables',
    SCHEMA_SIZE_KB: 'schemaSizeKb',
    MANUAL_ANNOTATION: 'manualAnnotation',
    CREATED_AT: 'createdAt',
    UPDATED_AT: 'updatedAt',
    PROCESSING_TIME: 'processingTime',
    USED_CREDITS: 'usedCredits',
    LLM_MODEL: 'llmModel',
    EMBEDDING_MODEL: 'embeddingModel',
});
